import React, { useEffect, useState } from 'react';
import Card from 'components/Layout/Card';
import { useParams, useSearchParams } from 'react-router-dom';
import ApprovalHub from './ApprovalHub/ApprovalHub';
import InstantPost from './InstantPost';
import './EventFormTab.scss';
import { useDispatch, useSelector } from 'react-redux';
import { throwError } from 'store/slices';

const EventFormTab = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));
  const { user_type } = userDetails;
  // const isEdit = params?.eventType === 'edit-event' ? true : false;
  // const isViewMode = params?.eventType === 'view-event' && !!params?.eventId;

  const [eventMode, setEventMode] = useState('add');

  useEffect(() => {
    if (params?.eventId === 'add-event') {
      setEventMode('add');
    } else if (params?.eventId) {
      setEventMode('edit');
    } else if (params?.eventType === 'view-event' && params?.eventId) {
      setEventMode('view');
    } else {
      setEventMode('add');
    }
  }, [params]);

  const isEditMode = eventMode === 'edit';
  const isViewMode = eventMode === 'view';
  const [tabType, setTabType] = useState('0');

  const activeClass = 'p-2 bg-new-car color-white text-14-500 br-5';
  const inActiveClass = 'p-2 color-dark-blue text-14-500 pointer br-5';
  const [searchParams] = useSearchParams();
  const isTemp = searchParams.get('istemp');
  return (
    <>
      <div id="event-form-tab-container">
        <Card className="d-flex align-items-center p-2 unset-br mb-3 br-10">
          <div className="d-flex align-items-center flex-wrap gap-4">
            <div
              className={tabType === '0' ? activeClass : inActiveClass}
              onClick={() => {
                setTabType('0');
              }}
            >
              Approval Hub
            </div>
            <div
              className={tabType === '1' ? activeClass : inActiveClass}
              onClick={() => {
                if (eventMode !== 'add' && !isTemp) {
                  setTabType('1');
                } else {
                  dispatch(
                    throwError({
                      message:
                        'The event has not been approved by the Super Admin yet.',
                    })
                  );
                }
              }}
            >
              Instant Post
            </div>
          </div>
        </Card>

        {tabType === '0' && (
          <ApprovalHub
            isViewMode={isViewMode}
            user_type={user_type}
            isEditMode={isEditMode}
          />
        )}
        {tabType === '1' && <InstantPost isViewMode={isViewMode} />}
      </div>
    </>
  );
};

export default EventFormTab;
